import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PageContainer, Typography } from '@guildeducationinc/recess';
import { FormActions } from '@src/components/Employee/FormActions/FormActions';
import { RequestSteps } from '@src/components/Employee/RequestSteps/RequestSteps';
import { FlowContainer } from '@src/components/FlowContainer/FlowContainer';
import { FullPageWrapper } from '@src/components/FullPageWrapper';
import { TopBar } from '@src/components/TopBar';
import { useAuth } from '@src/hooks/useAuth';
import { ProgramStatus } from '@src/types';
import { useLocale } from 'pe-core-frontend';
import { useNavigate } from 'react-router-dom';
import styles from './NewRequestIntro.module.scss';
export const NewProgramIntro = () => {
    const { t } = useLocale();
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const NEW_PROGRAM = {
        id: 0,
        clientId: currentUser?.clientId || 0,
        employeeId: currentUser?.employeeId || 0,
        purpose: {
            selections: [],
            other: undefined,
            isActive: true, //default to true for backward compatibility
            isRequired: true, //default to true for backward compatibility
        },
        status: ProgramStatus.PENDING,
        documents: { docs: [] },
        fieldOfStudyName: '',
        programName: '',
        otherSchool: '',
        otherFieldOfStudy: '',
        isSingleExpense: false,
    };
    const handleCancel = () => {
        navigate('/requests/new');
    };
    const handleOk = () => {
        navigate('/programs/new');
    };
    return (_jsxs(FullPageWrapper, { children: [_jsx(TopBar, { backLink: '/' }), _jsx(PageContainer, { children: _jsxs(FlowContainer, { children: [_jsxs("div", { className: styles.form, children: [_jsxs("div", { className: styles.heading, children: [_jsx(Typography, { weight: '300', variant: 'h1', children: t('Confirm coverage for your program') }), _jsx(Typography, { variant: 'body2', children: t('Program request intro') })] }), _jsx(RequestSteps, { program: NEW_PROGRAM })] }), _jsx(FormActions, { showBackArrow: true, cancelText: t('Previous'), onCancel: handleCancel, okText: t('Apply now'), onOk: handleOk })] }) })] }));
};
